import { NameEditDialog } from "@/components/modals/NameEditDialog";
import { useRenameSubcollectionMutation } from "@/modules/snapshots/snapshotCollection.api";

interface Props {
  open: boolean;
  onClose: () => void;
  subcollectionId: string;
  currentName: string;
}

export const RenameSubcollectionModal = ({ open, onClose, subcollectionId, currentName }: Props) => {
  const [renameSubcollection, { isLoading }] = useRenameSubcollectionMutation();

  const handleSubmit = async (name: string) => {
    await renameSubcollection({ id: subcollectionId, name: name.trim() }).unwrap();
  };

  const getErrorMessage = (error: unknown) => {
    const status = (error as { status?: number })?.status;
    if (status === 409) return "A sub-collection with this name already exists.";
    return "Could not rename sub-collection. Please try again.";
  };

  return (
    <NameEditDialog
      open={open}
      onClose={onClose}
      title="Rename Sub-collection"
      placeholder="Sub-collection name"
      currentName={currentName}
      isLoading={isLoading}
      onSubmit={handleSubmit}
      getErrorMessage={getErrorMessage}
    />
  );
};
